
//import components
import Background  from "../../components/background/Background"
import LanguageChanger from "../../components/languageChanger/LanguageChanger";
import TitleName from "../../components/titleName/TitleName";
import Menu from "../../components/menu/Menu";
import {useMenuContext} from "../../context/menuContext/MenuContext"
import { useEffect } from "react";

export default function Home() {
  const { MenuPageIndex,SetMenuPageIndex } = useMenuContext();
  
  useEffect(() => {
    SetMenuPageIndex(0)
  },[MenuPageIndex])

  return (
    <div id="Home">
      <Background />
      <LanguageChanger />
      <TitleName />
      <Menu />
    </div>
  );
}
